module.exports = __webpack_public_path__ + "img/face_auth_scene_3.f3d21ef1.png";